<script>

import datetimeRenderer from '@/views/components/renderers/datetime-renderer.vue'

export default {
  components: {  
    datetimeRenderer
  },
  created() {
    
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  }
};
</script>

<template>
  <datetime-renderer :value="value"></datetime-renderer>
</template>
